import { object, string } from 'yup'

export const addTaxFormSchema = object().shape({
  taxName: string().default('').nullable().required(),
  taxNumber: string().default('').nullable().required(),
  taxPercentage: string().default('').nullable().required(),
})
